import { blue, teal, yellow } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import ReceiptIcon from "@mui/icons-material/Receipt";

import { useNavigate } from "react-router-dom";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../GenericHomePage/GenericHomePage";
import StarIcon from "@mui/icons-material/Star";

const TreasuryCoordinatorHomePage = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    {
      textBeside: "Pending Orders",
      icon: ListAltRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.allPendingOrders),
      size: 4,
    },
    {
      textBeside: "Released Orders",
      icon: FactCheckRoundedIcon,
      iconColor: teal[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: teal[50],
      onClick: () => navigate(DefaultRoutes.allReleasedOrders),
      size: 4,
    },
    {
      textBeside: "Starred Orders",
      icon: StarIcon,
      iconColor: yellow[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: yellow[50],
      size: 4,
      onClick: () => navigate(DefaultRoutes.starredOrders),
    },
    {
      textBeside: "Transaction Listing",
      icon: ReceiptIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      size: 12,
      onClick: () => navigate(DefaultRoutes.transactionOrderListing),
    },
  ];
  return <GenericHomePage sectionsBox={sectionsBox} />;
};
export default TreasuryCoordinatorHomePage;
